import {Button, Grid, Paper, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SyntheticEvent} from "react";
import {FilterAltRounded, ReplayRounded, SearchRounded} from "@mui/icons-material";
import { CUR_ATTR_BY_STATUS_DMS } from "../../data";

const ActionFilters = ({setCurAttributes, searchDmsForm, handleSearch, filterExpandedState}: any) => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);

    const [filterExpanded, setFilterExpanded] = filterExpandedState;

    const handleResetForm = () => {
        searchDmsForm.reset();
        setCurAttributes(CUR_ATTR_BY_STATUS_DMS['DEFAULT'])
        handleSearch({});
    }

    const handleHideViewFilter = (e: SyntheticEvent) => {
        e.stopPropagation();
        setFilterExpanded(!filterExpanded);
    }

    return (
        <Grid item xs={6} md={3} sx={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
            <Button
                variant="text"
                color="accent"
                startIcon={<ReplayRounded />}
                sx={{mx: theme.spacing(0.5)}}
                onClick={handleResetForm}
            >
                {t('Reset')}
            </Button>

            <Button
                variant="text"
                color="accent"
                startIcon={<FilterAltRounded />}
                sx={{mx: theme.spacing(0.5)}}
                onClick={handleHideViewFilter}
            >
            { filterExpanded ? t('common.button.close') : t('common.advancedFilters') }
            </Button>

            <Button
                size="icon"
                color="accent"
                type="submit"
                onClick={searchDmsForm.handleSubmit(handleSearch)}
                sx={{ml: theme.spacing(0.5)}}
            >
                <SearchRounded />
            </Button>
        </Grid>
    )
}

export default ActionFilters;
